import script from "./ChangeLanguage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeLanguage.vue?vue&type=script&setup=true&lang=js"

import "./ChangeLanguage.vue?vue&type=style&index=0&id=403af100&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-403af100"]])

export default __exports__